// This file was previously called objSidebar.php.  The original objSidebar.php had a field
// SidebarPageManager, and so does this, but the file now named after it.
import DocsManager from './docsManager'
import TechNotesManager from './techNotesManager'
import { GLOBALS, LINKTYPES } from '../types'

export class LinkObj {
  key:string
  text:string
  type:string
  path:string
  /* eslint-disable @typescript-eslint/no-explicit-any */
  constructor (key:string, text:string, type:LINKTYPES, thing:any) {
    this.key = key
    this.text = text
    this.type = type
    // TO DO Are there ANY non-string args being passed any more?  Can we forget about 'thing'?
    this.path = typeof thing === 'string' ? thing : URL.createObjectURL(thing)
  }
}
export default class SidebarPageManager {
  // TO DO pageManager is an odd name choice, pages would be more descriptive
  pageManagers: {[index: string]:SidebarObj} = {}
  docsManager:DocsManager
  techNotesManager:TechNotesManager
  techList:Array<LinkObj>
  constructor (docsManager:DocsManager, techNotesManager:TechNotesManager) {
    this.pageManagers = {}
    this.docsManager = docsManager
    this.techNotesManager = techNotesManager
    this.techList = []
  }

  addPage (pageKey:string):SidebarObj {
    this.pageManagers[pageKey] = new SidebarObj(pageKey)
    return (this.getSidebar(pageKey))
  }

  getSidebar (pageKey:string):SidebarObj {
    return (this.pageManagers[pageKey])
  }

  load () {

    // Wow these are so old...
    /*
        const g_mavenBlogObj = new BlogObj2("maven", "Maven 2 Tutorial", LINKTYPES.external,
                "http://gregsandell.blogspot.com/2007/07/maven2-introduction-part-1-coordinate.html",
                "2007.07.13");
        const g_scorpBlogObj = new BlogObj2("scorp", "S-Corps for Software Contracters", LINKTYPES.external,const
                "http://gregsandell.blogspot.com/2006/10/s-corps-for-software-contracters.html",
                "2006.10.22");
        const g_roxyBlogObj = new BlogObj2("roxy", "New Roxy & Elsewhere Vid", LINKTYPES.external,const
                "http://gregsandell.blogspot.com/2017/06/new-roxy-elsewhere-video.html",
                "2017.06.29");
        const g_twinpeaksBlogObj = new BlogObj2("roxy", "Twin Peaks Season 3", LINKTYPES.external,const
                "http://gregsandell.blogspot.com/2017/06/dont-die-twin-peaks-s03e06-spoiler.html",
                "2017.06.26");
        const g_charsetLinkObj = new BlogObj2("characters", "Solving Character Set Problems", LINKTYPES.external,
                "http://gregsandell.blogspot.com/2009/01/solving-character-set-problems-ascii.html",
                "2009.05.15");
        const g_washingmachineBlogObj = new BlogObj2("washingMachine", "The Washing Machine", LINKTYPES.external,
                "http://gregsandell.blogspot.com/2017/02/the-washing-machine.html",
                "2017.02.23");
        */

    // Newer blogs
    const g_elAmorBrujoBlogObj = new BlogObj('elAmorBrujo', 'El Amor Brujo Concert Review', LINKTYPES.external,
      'http://gregsandell.blogspot.com/2019/11/santa-cecilia-orchestra-el-amor-brujo.html',
      '2019.11.11')
    const g_milkyWayBlogObj = new BlogObj('milkyWay', 'My Trip Through the Milky Way', LINKTYPES.external,
      'http://gregsandell.blogspot.com/2018/11/my-trip-through-milky-way.html',
      '2018.11.21')
    const g_zappa1971BlogObj = new BlogObj('zappa1971', 'Frank Zappa Concert, 1971', LINKTYPES.external,
      'http://gregsandell.blogspot.com/2018/03/remembering-frank-zappa-and-mothers-in.html',
      '2018.03.03')
    const g_jellyRollBlogObj = new BlogObj('jellyRoll', 'Jelly Roll Morton', LINKTYPES.external,
      'http://gregsandell.blogspot.com/2018/02/get-to-know-jelly-roll-morton.html',
      '2018.02.17')
    const g_appleHomepodBlogObj = new BlogObj('appleHomepod', 'Apple\'s HomePod: Review', LINKTYPES.external,
      'http://gregsandell.blogspot.com/2018/02/review-of-apples-homepod.html',
      '2018.02.12')
    const g_cecliaReviewBlogObj = new BlogObj('ceciliaReview', 'Beethoven & Handel Concert Review', LINKTYPES.external,
      'http://gregsandell.blogspot.com/2018/02/santa-cecilia-orchestra-plays-beethoven.html',
      '2018.02.12')
    const g_mahavishnuBlogObj = new BlogObj('mahavishnuReview', 'Mahavishnu Returns Concert Review', LINKTYPES.external,
      'http://gregsandell.blogspot.com/2017/12/mahavishnu-returns-royce-hall-ucla-2017.html',
      '2017.12.19')

    // Internal URLs.  These have their own tabs but there are places elsewhere in the site that link to them.
    const g_portfolioPageObj:LinkObj = new LinkObj('samples', 'Main Portfolio Page', LINKTYPES.internal, `/portfolio/${GLOBALS.lastClient}/splash`)
    // const g_billwhitneyLinkObj:LinkObj2 = new LinkObj2('billwhitney', 'Archived Live Site (MSIE Only)', LINKTYPES.internal, '/portfolio/samples/bwhitney')
    const g_resumeLinkObj:LinkObj = new LinkObj('resume', 'Resume', LINKTYPES.internal, '/resume')
    const g_codeLinkObj:LinkObj = new LinkObj('code', 'Code', LINKTYPES.internal, '/code')

    // Objects grouped under "more"
    const g_blogPageLinkObj:LinkObj = new LinkObj('blog', 'Blog', LINKTYPES.internal, '/blog')
    const g_talksLinkObj:LinkObj = new LinkObj('talks', 'Talks', LINKTYPES.internal, '/talks')
    const g_techLinkObj:LinkObj = new LinkObj('tech', 'Tech notes', LINKTYPES.internal, '/tech/list/all')
    const g_aboutLinkObj:LinkObj = new LinkObj('about', 'About This Site', LINKTYPES.internal, '/about')
    const g_techListLinkObj:LinkObj = new LinkObj('tech', 'Tech Notes List', LINKTYPES.backlink, '/tech/list/all')
    const g_publicationsLinkObj:LinkObj = new LinkObj('publications', 'Publications', LINKTYPES.internal, '/publications')
    const g_publicationsListLinkObj:LinkObj = new LinkObj('publications', 'Publications List', LINKTYPES.backlink, '/publications')

    // PDFs
    const g_dissertationLinkObj:LinkObj = new LinkObj('dissertation', 'PhD Dissertation', LINKTYPES.internal, '/dissertation')
    const g_mastersThesisLinkObj:LinkObj = new LinkObj('mastersThesis', 'Masters Thesis', LINKTYPES.internal, '/thesis')
    const g_pcaLinkObj:LinkObj = new LinkObj('pca', 'Timbre with PCA', LINKTYPES.external, this.docsManager.get('1995-12-01_perceptual_JAES'))
    const g_macroLinkObj:LinkObj = new LinkObj('macro', 'Macro Timbre', LINKTYPES.external, this.docsManager.get('1997-06-07_perceptual_ESCOM'))
    const g_pdfObj:LinkObj = new LinkObj('pdfFormat', 'PDF Format', LINKTYPES.internalStaticDownload, this.docsManager.get('resumePdf'))

    // External Websites
    const g_linkedInObj = new LinkObj('linkedIn', 'Linked In Profile', LINKTYPES.external, 'https://www.linkedin.com/in/gregsandell')
    const g_maxtradObj = new LinkObj('maxtrad', 'Official MaxTrad Site', LINKTYPES.external, 'http://www.maxtrad.com')
    const g_iesLinkObj = new LinkObj('iesLive', 'Live IES Site', LINKTYPES.external, 'http://www.iesabroad.org')
    const g_maytagLinkObj = new LinkObj('maytagLive', 'Live Maytag Site', LINKTYPES.external, 'http://www.maytag.com')
    const g_usafLinkObj = new LinkObj('usafLive', 'Live AF Portal', LINKTYPES.external, 'http://www.my.af.mil')
    const g_wattsLinkObj = new LinkObj('wattsLive', 'Live Watts Site', LINKTYPES.external, 'http://www.edwinwatts.org')
    const g_truvenLinkObj = new LinkObj('trCompanySite', 'Live Truven Site', LINKTYPES.external, 'http://www.truvenhealth.com')
    const g_searsLinkObj = new LinkObj('searsCompanySite', 'Live sears.com', LINKTYPES.external, 'http://www.sears.com')
    const g_tenxLinkObj = new LinkObj('tenxCompanySite', 'Live auction.com', LINKTYPES.external, 'http://www.auction.com')
    const g_crocsLinkObj = new LinkObj('crocsCompanySite', 'Live crocs.com', LINKTYPES.external, 'https://crocs.com')
    const g_zillowLinkObj = new LinkObj('zillowLiveSite', 'Live Zillow.com', LINKTYPES.external, 'https://zillowhomeloans.com')
    const g_fashionnovaLinkObj = new LinkObj('fashionnovaLiveSite', 'Live FashionNova.com', LINKTYPES.external, 'https://fashionnova.com')
    const g_pathfinderLinkObj = new LinkObj('pathfinderCompanySite', 'Live site', LINKTYPES.external, 'https://orthogonal.io')
    const g_firstAmLinkObj = new LinkObj('firstAmCompanySite', 'Live site', LINKTYPES.external, 'https://www.firstam.com')

    // MS-Word docs
    const g_mswordObj:LinkObj= new LinkObj('mswordResume', 'MS Word Format', LINKTYPES.internalStaticDownload, this.docsManager.get('resumeMsWordDoc'))

    //  Special case, perhaps don't remove
    const g_tech_list:LinkObj = new LinkObj('list', 'More...', LINKTYPES.internal, '/tech/list')

    //
    // PAGES HAVING THEIR OWN TABS
    //
    //
    // pageHome.php
    //
    let page = this.addPage('pageHome')

    page.addLinkObj(this.techNotesManager.toLinkObj('javascript'))
    page.addLinkObj(this.techNotesManager.toLinkObj('react'))
    page.addLinkObj(this.techNotesManager.toLinkObj('redux'))
    page.addLinkObj(this.techNotesManager.toLinkObj('typescript'))
    page.addLinkObj(this.techNotesManager.toLinkObj('node.js'))
    page.addLinkObj(this.techNotesManager.toLinkObj('aws'))
    page.addLinkObj(g_tech_list)
    //
    // pageResume.js
    //
    page = this.addPage('pageResume')
    page.addLinkObj(g_mswordObj)
    page.addLinkObj(g_pdfObj)
    page.addLinkObj(g_linkedInObj)
    page.addLinkObj(g_codeLinkObj)
    page.addBlogObj(g_elAmorBrujoBlogObj)
    page.addBlogObj(g_milkyWayBlogObj)
    page.addBlogObj(g_zappa1971BlogObj)
    page.addBlogObj(g_jellyRollBlogObj)
    page.addBlogObj(g_appleHomepodBlogObj)
    page.addBlogObj(g_cecliaReviewBlogObj)
    page.addBlogObj(g_mahavishnuBlogObj)
    //
    // pageMusic.js
    //
    page = this.addPage('pageMusic')
    page.addLinkObj(g_publicationsLinkObj)
    page.addBlogObj(g_elAmorBrujoBlogObj)
    page.addBlogObj(g_zappa1971BlogObj)
    page.addBlogObj(g_jellyRollBlogObj)
    page.addBlogObj(g_cecliaReviewBlogObj)
    page.addBlogObj(g_mahavishnuBlogObj)

    // TO DO looks like we don't need this any more
    // page = this.addPage('portfolio') // this is just so LinksArray will be empty array

    //
    // pagePortfolio
    //
    page = this.addPage('pagePortfolio')
    page.addLinkObj(g_portfolioPageObj)
    page.addBlogObj(g_elAmorBrujoBlogObj)
    page.addLinkObj(g_publicationsLinkObj)
    page.addBlogObj(g_milkyWayBlogObj)

    //
    // pageCode.js
    //
    page = this.addPage('pageCode')
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_talksLinkObj)
    page.addLinkObj(g_resumeLinkObj)

    //
    // pageMore
    //
    page = this.addPage('pageMore')
    page.addLinkObj(g_blogPageLinkObj)
    page.addLinkObj(g_talksLinkObj)
    page.addLinkObj(g_publicationsLinkObj)
    page.addLinkObj(g_techLinkObj)
    page.addLinkObj(g_aboutLinkObj)

    //
    // PAGES INTERNAL TO THE "MORE" SECTION
    //
    // innerPagePublications.js
    //
    page = this.addPage('pagePublications')
    page.addLinkObj(g_blogPageLinkObj)
    page.addLinkObj(g_talksLinkObj)
    page.addLinkObj(g_techLinkObj)
    page.addLinkObj(g_aboutLinkObj)
    page.addLinkObj(g_publicationsListLinkObj)
    page.addLinkObj(g_pcaLinkObj)
    page.addLinkObj(g_macroLinkObj)

    //
    // pageThesis
    //
    page = this.addPage('pageThesis')
    page.addLinkObj(g_blogPageLinkObj)
    page.addLinkObj(g_talksLinkObj)
    page.addLinkObj(g_publicationsListLinkObj)
    page.addLinkObj(g_techLinkObj)
    page.addLinkObj(g_aboutLinkObj)
    page.addLinkObj(g_dissertationLinkObj)

    //
    // pageDissertation
    //
    page = this.addPage('pageDissertation')
    page.addLinkObj(g_blogPageLinkObj)
    page.addLinkObj(g_talksLinkObj)
    page.addLinkObj(g_publicationsLinkObj)
    page.addLinkObj(g_techLinkObj)
    page.addLinkObj(g_aboutLinkObj)
    page.addLinkObj(g_publicationsListLinkObj)
    page.addLinkObj(g_mastersThesisLinkObj)

    //
    // pageBlogs.php
    //
    page = this.addPage('pageBlog')
    page.addLinkObj(g_talksLinkObj)
    page.addLinkObj(g_publicationsLinkObj)
    page.addLinkObj(g_techLinkObj)
    page.addLinkObj(g_aboutLinkObj)
    page.addBlogObj(g_elAmorBrujoBlogObj)
    page.addBlogObj(g_milkyWayBlogObj)

    //
    // pageTalks
    //
    page = this.addPage('pageTalks')
    page.addLinkObj(g_blogPageLinkObj)
    // page.addLinkObj(g_talksLinkObj) // silly to have link to self
    page.addLinkObj(g_publicationsLinkObj)
    page.addLinkObj(g_techLinkObj)
    page.addLinkObj(g_aboutLinkObj)

    //
    // pageTech
    //
    page = this.addPage('pageTech')
    page.addLinkObj(g_blogPageLinkObj)
    page.addLinkObj(g_talksLinkObj)
    page.addLinkObj(g_publicationsLinkObj)
    page.addLinkObj(g_techListLinkObj)
    page.addLinkObj(g_aboutLinkObj)

    //
    // pageAbout
    //
    page = this.addPage('pageAbout')
    page.addLinkObj(g_blogPageLinkObj)
    page.addLinkObj(g_talksLinkObj)
    page.addLinkObj(g_publicationsLinkObj)
    page.addLinkObj(g_techListLinkObj)
    page.addLinkObj(g_aboutLinkObj)



    //
    // CLIENT PAGES
    //
    //
    // pageClient_zillow
    //
    page = this.addPage('pageClient_zillow')
    page.addLinkObj(g_zillowLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_firstAm
    //
    page = this.addPage('pageClient_firstAm')
    page.addLinkObj(g_firstAmLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_fashionnova
    //
    page = this.addPage('pageClient_fashionnova')
    page.addLinkObj(g_fashionnovaLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_crocs
    //
    page = this.addPage('pageClient_crocs')
    page.addLinkObj(g_crocsLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_tenx
    //
    page = this.addPage('pageClient_tenx')
    page.addLinkObj(g_tenxLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_sears
    //
    page = this.addPage('pageClient_sears')
    page.addLinkObj(g_searsLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_path
    //
    page = this.addPage('pageClient_pathfinder')
    page.addLinkObj(g_pathfinderLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_tr
    //
    page = this.addPage('pageClient_truven')
    page.addLinkObj(g_truvenLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_abnAmro
    //
    page = this.addPage('pageClient_abnAmro')
    page.addLinkObj(g_maxtradObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_amex
    //
    page = this.addPage('pageClient_amex')
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_billwhitney
    //
    page = this.addPage('pageClient_billwhitney')
    // page.addLinkObj(g_billwhitneyLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_ies
    //
    page = this.addPage('pageClient_ies')
    page.addLinkObj(g_iesLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_maytag
    //
    page = this.addPage('pageClient_maytag')
    page.addLinkObj(g_maytagLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_ubs
    //
    page = this.addPage('pageClient_ubs')
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_usaf
    //
    page = this.addPage('pageClient_usaf')
    page.addLinkObj(g_usafLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_watts
    //
    page = this.addPage('pageClient_watts')
    page.addLinkObj(g_wattsLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_xb
    //
    page = this.addPage('pageClient_xb')
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_spectrum
    //
    page = this.addPage('pageClient_spectrum')
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
  }
}
class SidebarObj {
  pageKey:string
  // TO DO the two items below are not Arrays, rename them
  linksArray: {[index: string]:LinkObj} = {}
  blogsArray: {[index: string]:BlogObj} = {}
  constructor (pageKey:string) {
    this.pageKey = pageKey
    this.linksArray = {} // TODO change to linksHash
    this.blogsArray = {} // TODO change to blogsHash
  }

  // Dead code!
  // addLink (key:string, text:string, type:string, url:string) {
  //   this.linksArray[key]:LinkObj2 = new LinkObj2(key, text, type, url)
  // }
  //
  // addBlog (key:string, text:string, url:string, date:string) {
  //   this.blogsArray[key] = new BlogObj2(key, text, url, date)
  // }

  addLinkObj (linkObj:LinkObj):void {
    this.linksArray[linkObj.key] = linkObj
  }

  addBlogObj (blogObj:BlogObj):void {
    this.blogsArray[blogObj.key] = blogObj
  }
}
class BlogObj {
  key:string
  text:string
  type:LINKTYPES // TO DO can remove because a BlogObj is always type external
  url:string
  date:string
  constructor (key:string, text:string, type:LINKTYPES, url:string, date:string) {
    this.key = key
    this.text = text
    this.type = type
    this.url = url
    this.date = date
  }
}
